import { useMemo } from 'react'
import styled from 'styled-components'

import Box from '../Box'
import Flex from 'components/Flex'

import Window, { Title } from '.'
import { TaskbarProps } from './types'
import { Z_INDEX } from 'utils/constants'

const Taskbar = <D extends string>({ onCloseWindow, onMinimizeWindow, onRestoreWindow, windows }: TaskbarProps<D>) => {
  const widthOffWiallOpenWidows = useMemo(
    () => windows.filter((w) => !w.isMinimized).reduce((acc, window) => acc + (Number(window.width) || 0), 0),
    [windows],
  )

  return (
    <>
      <MinimizedContainer style={{ right: `${widthOffWiallOpenWidows + 10}px` }}>
        <Flex gap="2px">
          {windows?.map(
            (w, index) =>
              w?.isMinimized && (
                <Box
                  key={index}
                  mx="4px"
                  onClick={(e) => {
                    if (e) {
                      e.stopPropagation()
                    }
                    onRestoreWindow(w.windowId)
                  }}
                >
                  <Title
                    {...w}
                    onClose={(e) => {
                      if (e) {
                        e.stopPropagation()
                      }
                      onCloseWindow(w.windowId)
                    }}
                  />
                </Box>
              ),
          )}
        </Flex>
      </MinimizedContainer>
      <Container>
        {windows.map((i) => (
          <Box key={i.windowId} mx="4px" display={i.isMinimized ? 'none' : 'block'}>
            <Window
              {...i}
              onMinimize={(e) => {
                if (e) {
                  e.stopPropagation()
                }
                onMinimizeWindow(i.windowId)
              }}
              onClose={(e) => {
                if (e) {
                  e.stopPropagation()
                }
                onCloseWindow(i.windowId)
              }}
            >
              {i.children}
            </Window>
          </Box>
        ))}
      </Container>
    </>
  )
}

const Container = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: flex-end;
`
const MinimizedContainer = styled.div`
  bottom: 0;
  position: fixed;
  z-index: ${Z_INDEX.window};
`

export default Taskbar
